function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import "jquery";
/**
 * パスワードリセット
 */

var ForgotPasswordSmartPhone = /*#__PURE__*/function () {
  /**
   * 初期化を行います。
   *
   * @param common 共通
   */
  function ForgotPasswordSmartPhone(common) {
    _classCallCheck(this, ForgotPasswordSmartPhone);

    this.common = common;
  }
  /**
   * HTMLの構造が組み立てられた後すぐに実施する処理
   */


  _createClass(ForgotPasswordSmartPhone, [{
    key: "ready",
    value: function ready() {
      var _this = this;

      this.common.ready();
      this.common.bind();
      $(document).on("keydown", function (e) {
        switch (e.keyCode) {
          //エンター
          case 13:
            _this.common.submit(function () {
              _this.common.createAction("ForgotPassword");
            }, true, false);

            return false;

          default:
            return true;
        }
      });
      var $page = $("#ForgotPassword_SmartPhone");
      $page.find("#ForgotPasswordButton").on('click', function (e) {
        _this.common.submit(function () {
          _this.common.createAction("ForgotPassword");
        }, true, false);

        e.preventDefault();
      });
    }
  }]);

  return ForgotPasswordSmartPhone;
}();

export { ForgotPasswordSmartPhone as default };